<template>
  <footer class="site-footer">
    <span>© 易尤特集团</span>
    <span>©2003-2022 All Rights Reserved <a href="https://beian.miit.gov.cn/#/Integrated/index">ICP备17027634号-2</a></span>
  </footer>
</template>
<script>
export default {
  name: "AppFooter"
};
</script>

<style lang="less" scoped>
.site-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 24px clamp(22px, 5vw, 76px);
  color: rgba(255, 255, 255, 0.68);
  font-size: 13px;
  background: #061e3b;
}

@media (max-width: 680px) {
  .site-footer {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
